/**
 * EcoFlow 自有的媒体存储 / CDN 域名。
 *
 * consentmanager（us、it 站点接入）的自动拦截会扫描 DOM，把无法归属到某个 vendor 的外域资源
 * 的 `src` 摘到 `data-cmp-src` 上并标记 `data-cmp-vendor="unknownVendor"`，等拿到对应 vendor
 * 的同意后再放行。这些域名都是自家内容存储，压根不存在对应的 vendor，一旦被拦就永远不会恢复，
 * 表现为图片 / 视频空白。所以需要在 autoblocking 脚本执行前把它们登记为忽略域名。
 *
 * 新增自有媒体域名时同步往这里加。注意与 `eco-design/base/eco-img` 里的 `OSS_HOSTS` 区分：
 * 那份列表是用来判断能否拼 `?x-oss-process=` 图片处理参数的，范围更窄，两者不要合并。
 */
export const ECOFLOW_MEDIA_HOSTS = [
    // 站点静态资源与图片
    'websiteoss.ecoflow.com',
    'media.ecoflow.com',
    'videos.ecoflow.com',

    // 业务媒体 CDN（按区域划分）
    'ecoflow-service-us-cdn.ecoflow.com',
    'ecoflow-service-eu-cdn.ecoflow.com',
    'ecoflow-service-cn-cdn.ecoflow.com',
    'ecoflow-service-test-cdn.ecoflow.com',

    // OSS 源站。部分接口直接返回裸 OSS 地址，例如用户上传后回传的图片
    'ecoflow-service-cn-prod.oss-cn-shenzhen.aliyuncs.com',
    'ecoflow-service-us-prod.oss-us-west-1.aliyuncs.com',
    'ecoflow-service-eu-prod.oss-eu-central-1.aliyuncs.com',
    'ecoflow-service-test.oss-cn-shenzhen.aliyuncs.com',
    'ef-website-uat.oss-cn-shenzhen.aliyuncs.com',
    'aiwoman1.oss-cn-shenzhen.aliyuncs.com',
];
